import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';
import tools from '../tools/tools.js';
import toolsMarkup from '../markup/tools.js';
import usersMarkup from '../markup/users-List.js';
import mainPage from '../lk/mainPage.js';


const regVal = window.appSettings.registerValid;

const loaderSpinnerId = 'loader-enterprises';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);
// const usersGroupsBox = document.querySelector('#usersGroupsBox');
const menuBt = document.querySelector('#MenuListOfUsers');

const mainTabPane = document.querySelector('#cntUsers');
const mainTabPaneBTReload = mainTabPane.querySelector('button[name=refresh]');
const mainTabPaneBTAdd = mainTabPane.querySelector('button[name=add]');
const mainTabPaneBody = mainTabPane.querySelector('div[name=body]');
// const listPointsBody = document.querySelector('#cntUsers').querySelector('div[name=""]');

const navNameCurFest = document.querySelector('#nameFest');
const navListAllFest = document.querySelector('#listAllFEsts');
const cardUserAdd = document.querySelector('#cntuser-add');


const cardUserAddFio = cardUserAdd.querySelector('input[name=FIO]');
const cardUserAddEMail = cardUserAdd.querySelector('input[name=email]');
const cardUserAddlicAgree = cardUserAdd.querySelector('input[name=licAgree]');
const cardUserAddPhone = cardUserAdd.querySelector('input[name=phone]');
const cardUserAddSubmit = cardUserAdd.querySelector('button[name=submit]');


const cardUser = document.querySelector('#cntuser-card');
const cardUserBtChangeStatus = cardUser.querySelector('button[name=changeStatus]');

let allUsers;
let activeTab = 2;
let cardUserID = 0;
let listAllFEstivals;

const onSuccessPointsLoad = (loadedAnswer) => {
  // document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedAnswer.status === 200) {
    cardUserAddFio.value = '';
    cardUserAddFio.classList.remove('inputSuccess');
    cardUserAddEMail.value = '';
    // cardUserAddEMail.classList.remove()
    cardUserAddPhone.value = '';
    cardUserAddPhone.classList.remove('inputSuccess');
    cardUserAddlicAgree.checked = false;


    mainTabPane.querySelector('h3[name=ownFIO]').innerHTML = loadedAnswer.data.ownInfo.name;
    mainTabPane.querySelector('h5[name=ownPhone]').innerHTML = tools.formatedPhone(loadedAnswer.data.ownInfo.phone);

    // console.log(parseInt(loadedAnswer.data);
    if (parseInt(loadedAnswer.data.ownInfo.parentUser, 10) >0) {
      mainTabPane.querySelector('div[name=ownType]').innerHTML = '';
      mainTabPane.querySelector('div[name=bodyHeader]').style.display = 'none';
      mainTabPane.querySelector('div[name=body]').style.display = 'none';
    } else {
      mainTabPane.querySelector('div[name=ownType]').innerHTML = 'Главный администратор';
      mainTabPane.querySelector('div[name=bodyHeader]').style.display = 'flex';
      mainTabPane.querySelector('div[name=body]').style.display = 'block';
    }


    allUsers = loadedAnswer.data.users;
    filterUser();


    let dateNOW = new Date();
    mainTabPane.querySelector('div[name=localTime]').innerHTML = dateNOW.toUTCString();
  }
};
function filterUser(){

   usersMarkup.drawDataInContainer(allUsers);

}
mainTabPaneBody.addEventListener('click', function (evt) {
  if(evt.target.attributes.userID){
    cardUserID = evt.target.attributes.userID.nodeValue;
    // console.log(evt.target.attributes.userID);
    xhr.request = {
      metod: 'GET',
      url: `users/${evt.target.attributes.userID.nodeValue}/cardInfo`,
      data: '',
      callbackSuccess: onSuccessUserCardLoad
    };
  }
});

  
const onSuccessUserCardLoad = (loadedAnswer) => {

  // document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedAnswer.status === 200) {
    cardUser.querySelector('h3[name=FIO]').innerHTML = loadedAnswer.data.name;
    cardUser.querySelector('h5[name=mail]').innerHTML = loadedAnswer.data.mail;
    cardUser.querySelector('h5[name=phone]').innerHTML = tools.formatedPhone(loadedAnswer.data.phone);

    cardUser.querySelector('label[name=dateReg]').innerHTML = tools.dateStringFull(loadedAnswer.data.regTime);
    cardUser.querySelector('b[name=dateLastActive]').innerHTML = tools.dateStringFull(loadedAnswer.data.lastActive);
    cardUser.querySelector('b[name=nameFest]').innerHTML = loadedAnswer.data.festival;


    cardUser.querySelector('button[action=changeStatus]').classList.remove('icon-btn__lock-user');
    cardUser.querySelector('button[action=changeStatus]').classList.remove('icon-btn__unlock-user');

    if (parseInt(loadedAnswer.data.status, 10) === 0) {
      cardUser.querySelector('b[name=status]').innerHTML = 'Отключен';
      cardUser.querySelector('button[action=changeStatus]').classList.add('icon-btn__unlock-user');
    } else {
      cardUser.querySelector('b[name=status]').innerHTML = 'Актвен';
      cardUser.querySelector('button[action=changeStatus]').classList.add('icon-btn__lock-user');
    }
     
    displayMETA(loadedAnswer.data.metaFests);

     // тут информация про фестивали
    $(cardUser).modal('show');
      // getUsers();
  }

};

const onSuccessUserCardMetaLoad = (loadedAnswer) => {
  if (loadedAnswer.status === 200)
    displayMETA(loadedAnswer.data);
}

function displayMETA(dataMeta){
    let festMetaProperty = `<table class="w-100">
                              <tr>
                                <td>Фестиваль:</td>
                                <td><small>Просмотр</small></td>
                                <td><div class="div-table-header-container"><small>Ответст. за<br>модерацию</small></div></td>
                                <td><div class="div-table-header-container"><small>Редактрование<br>программ</small></div></td>
                                <td><div class="div-table-header-container"><small>Выгрузка<br>в Excel</small></div></td>
                                <td><div class="div-table-header-container"><small>Групповая<br>рассылка</small></div></td>
                                <td><div class="div-table-header-container"><small>B2B</small></div></td>
                                <td><div class="div-table-header-container"><small>Доступ <br>к заявкам</small></div></td>
                                <td><div class="div-table-header-container"><small>Локальные<br>заметки</small></div></td>
                                <td><div class="div-table-header-container"><small>Чат с<br>заявителем</small></div></td>
                                <td><div class="div-table-header-container"><small>Информация<br>о заявителе</small></div></td>
                              </tr>`;
    if (listAllFEstivals && listAllFEstivals.length > 0) {
      listAllFEstivals.forEach((item) => {
        // перебор meta только этого пользователя
        let boxAvailable = false;
        let boxReviewer = false;
        let boxEditProgramAndShedule = false;
        let boxExportExcel = false;
        let boxGroupMailing = false;
        let boxworkb2b = false;

        let boxcardTabWork = 0 ;
        let boxcardTabLocalNotes = 0 ;
        let boxcardTabChats = 0 ;
        let boxcardTabReqInfo = 0 ;



        if(dataMeta)
          dataMeta.forEach((row) => {
            if(row.id === item.id){
              console.log(row);
              boxAvailable = true;
              boxReviewer = parseInt(row.reviewer, 10);
              boxEditProgramAndShedule = parseInt(row.eventMaker, 10);
              boxExportExcel = parseInt(row.exportExcel, 10);
              boxGroupMailing = parseInt(row.groupMailing, 10);
              boxworkb2b = parseInt(row.workb2b, 10);

              boxcardTabWork = parseInt(row.cardTabWork, 10);
              boxcardTabLocalNotes = parseInt(row.cardTabLocalNotes, 10);
              boxcardTabChats = parseInt(row.cardTabChats, 10);
              boxcardTabReqInfo = parseInt(row.cardTabReqInfo, 10);
            }
          });

        festMetaProperty = `${festMetaProperty}
                            <tr>
                              <td>${boxAvailable ? `<b>${item.name}<b>` : item.name}</td>
                              <td><div class="div-table-container"><input type="checkbox" ${boxAvailable ? 'checked':''} nameMeta="available" festID="${item.id}"></div></td>
                              <td><div class="div-table-container"><input ${!boxAvailable && 'disabled'} type="checkbox" ${boxReviewer ? 'checked':''}  nameMeta="reviewer" festID="${item.id}"></div></td>
                              <td><div class="div-table-container"><input ${!boxAvailable && 'disabled'} type="checkbox" ${boxEditProgramAndShedule ? 'checked':''}  nameMeta="eventMaker" festID="${item.id}"></div></td>
                              <td><div class="div-table-container"><input ${!boxAvailable && 'disabled'} type="checkbox" ${boxExportExcel ? 'checked':''}  nameMeta="exportExcel" festID="${item.id}"></div></td>
                              <td><div class="div-table-container"><input ${!boxAvailable && 'disabled'} type="checkbox" ${boxGroupMailing ? 'checked':''}  nameMeta="groupMailing" festID="${item.id}"></div></td>
                              <td><div class="div-table-container"><input ${!boxAvailable && 'disabled'} type="checkbox" ${boxworkb2b ? 'checked':''}  nameMeta="workb2b" festID="${item.id}"></div></td>
                              <td><div class="div-table-container"><div class="${!boxAvailable && 'cardTabStatusDisabled'}  cardTabStatus cardTabStatus${boxcardTabWork}" metaValue=${boxcardTabWork} nameMeta="cardTabWork" festID="${item.id}"></div></div></td>
                              <td><div class="div-table-container"><div class="${!boxAvailable && 'cardTabStatusDisabled'}  cardTabStatus cardTabStatus${boxcardTabLocalNotes}"   metaValue=${boxcardTabLocalNotes}  nameMeta="cardTabLocalNotes" festID="${item.id}"></div></div></td>
                              <td><div class="div-table-container"><div class=" ${!boxAvailable && 'cardTabStatusDisabled'}  cardTabStatus cardTabStatus${boxcardTabChats}"  metaValue=${boxcardTabChats} nameMeta="cardTabChats" festID="${item.id}"></div></div></td>
                              <td><div class="div-table-container"><div class=" ${!boxAvailable && 'cardTabStatusDisabled'}  cardTabStatus cardTabStatus${boxcardTabReqInfo}"  metaValue=${boxcardTabReqInfo} nameMeta="cardTabReqInfo" festID="${item.id}"></div></div></td>
                            </tr>`;
      });
    }
    festMetaProperty = `${festMetaProperty}</table>`;

    cardUser.querySelector('div[name=metaFestBody]').innerHTML = festMetaProperty;
}


cardUser.addEventListener('click', function (evt) {
  if(evt.target.attributes.nameMeta){

    let newValue = 0;

    if(evt.target.attributes.metaValue){

      newValue = parseInt(evt.target.attributes.metaValue.nodeValue,10) + 1;
      if(newValue === 3)
        newValue = 0;
    } else
      newValue = evt.target.checked ? 1 : 0;


    xhr.request = {
      metod: 'PUT',
      url: `users/${cardUserID}/metaFest`,
      data: `festID=${evt.target.attributes.festID.nodeValue}&action=${evt.target.attributes.nameMeta.nodeValue}&enabled=${newValue}`,
      callbackSuccess: onSuccessUserCardMetaLoad
    };
  } else if(evt.target.attributes.action && (evt.target.attributes.action.nodeValue === 'changeStatus')){
      console.log(evt.target.attributes.action.nodeValue);
    let newStatus = 0;
    if (cardUser.querySelector('b[name=status]').innerHTML === 'Отключен')
      newStatus = 1;

    xhr.request = {
      metod: 'PUT',
      url: `users/${cardUserID}/status/${newStatus}`,
      data: '',
      callbackSuccess: onSuccessUserStatusLoad
    };

  } 
});


const onSuccessUserStatusLoad = (loadedAnswer) => {
  if (loadedAnswer.status === 200){
    getUsers();
    $(cardUser).modal('hide');
    // onSuccessUserCardLoad(loadedAnswer);
  }
}
mainTabPaneBTReload.addEventListener('click', function (evt) {
  getUsers();
  // body...
});
mainTabPaneBTAdd.addEventListener('click', function (evt) {
    $(cardUserAdd).modal('show');
  // body...
});


cardUserAddFio.addEventListener('keyup', function (evt) {
    validationData();
  // body...
});

cardUserAddEMail.addEventListener('keyup', function (evt) {
    validationData();
  // body...
});

cardUserAddPhone.addEventListener('keyup', function (evt) {
    validationData();
  // body...
});

cardUserAddlicAgree.addEventListener('click', function (evt) {
    validationData();
  // body...
});
function validationData() {
  let validAnswer = true;

  cardUserAddFio.classList.remove('inputError');
  cardUserAddEMail.classList.remove('inputError');
  // cardUserAddlicAgree.classList.remove('inputError');


  if(cardUserAddFio.value.length < 3){
    validAnswer = false;
    cardUserAddFio.classList.remove('inputSuccess');
  }
  else
    cardUserAddFio.classList.add('inputSuccess');

  if(cardUserAddPhone.value.length < 10){
    cardUserAddPhone.classList.remove('inputSuccess');
    validAnswer = false;
  } else 
    cardUserAddPhone.classList.add('inputSuccess');

  if(cardUserAddEMail.value.length > 1){
    // if()
      // if (!regVal.email.test(cardUserAddEMail.value)) {

      if(!String(cardUserAddEMail.value).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
          validAnswer = false;
          cardUserAddEMail.classList.remove('inputSuccess');
          cardUserAddEMail.classList.add('inputError');


      } else 
        cardUserAddEMail.classList.add('inputSuccess');
  } else
    cardUserAddEMail.classList.add('inputSuccess');


  if(!cardUserAddlicAgree.checked)
    validAnswer = false;
  
  if(validAnswer)
    cardUserAddSubmit.disabled = false;
  else
    cardUserAddSubmit.disabled = true;
}


cardUserAddSubmit.addEventListener('click', function (evt) {

  xhr.request = {
    metod: 'POST',
    url: `users/${auth.data.operatorId}/addNew`,
    data: `name=${cardUserAddFio.value}&phone=7${cardUserAddPhone.value}&mail=${cardUserAddEMail.value}`,
    callbackSuccess: onSuccessAddLoad
  };
});

const onSuccessAddLoad = (loadedAnswer) => {

  // document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedAnswer.status === 200) {

    $(cardUserAdd).modal('hide');
    getUsers();
  }

};

// usersGroupsBox.addEventListener('click', function (evt) {

//   if(evt.target.attributes.groupType){

//     [].forEach.call(usersGroupsBox.getElementsByClassName('userGroup'), function (divElement) {
//       // divElement.classList.remove('userGroupActive');
//       // console.log(divElement.attributes);  
//       if(evt.target.attributes.groupType.nodeValue == divElement.attributes.groupType.nodeValue)
//         divElement.classList.add('userGroupActive');
//       else
//         divElement.classList.remove('userGroupActive');
//     });


//   }
// });
// document.querySelector('#usersList-refresh-btn').addEventListener('click', function () {
//   getUsers();
// });

const getUsers = () => {

  // pointsMarkup.cleanContainer();
  // pointsMarkup.drawMarkupInContainer(loaderSpinnerMarkup);

  xhr.request = {
    metod: 'GET',
    url: 'users/0/list',
    data: '',
    callbackSuccess: onSuccessPointsLoad
  };
};
const getListOfFestivals = () => {
  if (auth.data.operatorId)
    xhr.request = {
      metod: 'GET',
      url: `users/${auth.data.operatorId}/listOfFestivals`,
      data: `token=${auth.data.token}`,
      callbackSuccess: onSuccessListOfFestivals
    };
  else 
    alert('Необходимо заново пройти авторизацию!');
};

const onSuccessListOfFestivals  = (loadedAnswer) => {
  if (loadedAnswer.status === 200) {
    listAllFEstivals = loadedAnswer.data;
    navNameCurFest.innerHTML = listAllFEstivals[0].name;
    auth.currentFestival = listAllFEstivals[0].id;


    if(listAllFEstivals[0].permissions)
      auth.permissionsOnFest = JSON.stringify(listAllFEstivals[0].permissions);

    displayFestListInMenu();

    mainPage.reloadData();
  }

};

function displayFestListInMenu() {
  let HTMLlistA = '';
  if (listAllFEstivals && listAllFEstivals.length > 0) {
  listAllFEstivals.forEach((item) => {
    HTMLlistA = `${HTMLlistA}   <a class="dropdown-item row m-0 ${auth.currentFestival == item.id && "currentFest"}"  festivalID=${item.id} festivalName="${item.name}"  role="tab"><span class="${auth.currentFestival == item.id && "currentName"}"  festivalID=${item.id} festivalName="${item.name}"  >${item.name} </span> ${auth.currentFestival === item.id ? "<div class='iconHomeFest' action='openMenu'></div>" :""} </a>`;
  });
  navListAllFest.innerHTML = HTMLlistA;
  // console.log(HTMLlistA);
}

}
navListAllFest.addEventListener('click', function (evt) {
  // console.log(evt.target.attributes);
  if(evt.target.attributes.action){
    // alert('fsgdf');  
    mainPage.show();

  } else if(evt.target.attributes.festivalID){
    if(confirm(`Переключить на "${evt.target.attributes.festivalName.nodeValue}"?`))
      xhr.request = {
        metod: 'PUT',
        url: `users/${auth.data.operatorId}/currentFestival`,
        data: `token=${auth.data.token}&festID=${evt.target.attributes.festivalID.nodeValue}`,
        callbackSuccess: (loadedAnswer) => {
          if (loadedAnswer.status) {
            navNameCurFest.innerHTML = evt.target.attributes.festivalName.nodeValue;
            auth.currentFestival = evt.target.attributes.festivalID.nodeValue;
            displayFestListInMenu();
            auth.permissionsOnFest = JSON.stringify(loadedAnswer.data); 
            mainPage.reloadData();
     
              if(document.querySelector('#filmAFConsider').classList.contains('active'))
              tools.eventFire(document.getElementById('filmAFConsider-bt-reload'), 'click');
              
          }
          //console.log();
        }
      };
   
    }
 
});


 // <a class="dropdown-item" id="MenuInputFilmsRequests" data-toggle="list" href="#films" role="tab" aria-controls="docs">Входящие заявки</a>
 //              <a class="dropdown-item" id="MenuAllFilms" data-toggle="list" href="#films" role="tab" aria-controls="docs">Фильмы фестиваля</a>
 //              <a class="dropdown-item" id="MenuProgrammsOfFilms" data-toggle="list" href="#programmsFest" role="tab" aria-controls="docs" >Программы показов</a>
 //              <a class="dropdown-item" id="MenuNominationsAndResults" data-toggle="list" href="#programmsFest" role="tab" aria-controls="docs">Номинации и результаты</a>

export default {

  start() {
    // getBlue();
    getListOfFestivals();
      menuBt.addEventListener('click', getUsers);
  },

  stop() {
    // pointsMarkup.cleanContainer();
   menuBt.removeEventListener('click', getUsers);
  }
};
